import { CpaStatus } from '../../../data-layer/cpa/types';

export const WALLET_RELEVANT_STATUSES = [CpaStatus.TRIAL, CpaStatus.ACCEPTED];

export const HIDE_BUTTON_STATUSES = [
    CpaStatus.NOT_REGISTERED,
    CpaStatus.TRIAL_EXPIRED,
    CpaStatus.NOT_PORTAL_USER,
    CpaStatus.PDD_USER,
];
